'use strict';

import RegistrationApi from '@api/registration';

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::registration]';

const launch = async (registration) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await RegistrationApi.launch(registration.id);
    return response.data;
}

export default {
    launch
};